var _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.24748,
    y1: 9.3415,
    x2: 13.2475,
    y2: 1.3415,
    stroke: "white",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.24748,
    y1: 9.3415,
    x2: 13.2475,
    y2: 1.3415,
    stroke: "white",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6.24748,
    y1: 9.3415,
    x2: 13.2475,
    y2: 1.3415,
    stroke: "white",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6.29295,
    y1: 10.7071,
    x2: 1.29295,
    y2: 5.70711,
    stroke: "white",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 6.29295,
    y1: 10.7071,
    x2: 1.29295,
    y2: 5.70711,
    stroke: "white",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 6.29295,
    y1: 10.7071,
    x2: 1.29295,
    y2: 5.70711,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTick);
export default __webpack_public_path__ + "static/media/white-tick.36765b7e55fad8b023bde3673ef56df5.svg";
export { ForwardRef as ReactComponent };